import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, combineLatest, Subject, Subscription } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { debounceTime, filter, startWith, switchMap, take, takeUntil } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { Offer } from '../../../classes';
import { PaginationPage, PaginationResponse } from 'src/app/classes';
import { OfferService } from '../../../services/offer.service';

@Component({
  selector: 'app-select-offer-dialog',
  templateUrl: './select-offer-dialog.component.html',
  styleUrls: ['./select-offer-dialog.component.css']
})
export class SelectOfferDialogComponent implements OnInit {

  offers: Offer[] = [];

  formControl: FormControl = new FormControl();

  page: PaginationPage = { 'pageNumber': 1, 'pageSize': 20 };

  total: number = 0;

  private _searching = new BehaviorSubject(false);
  private _searchImmediately = new Subject<void>();
  private _subscriptions: Subscription[] = [];

  constructor(
    private _dialogRef: MatDialogRef<SelectOfferDialogComponent>,
    private _offerService: OfferService
  ) { }

  close(){
    this._dialogRef.close();
  }

  offerClicked(offer: Offer){
    this._dialogRef.close(offer);
  }
  
  loadMore(){
    if(!this._searching.value && this.total > this.offers.length){
      this.page.pageNumber++;
      this._searching.next(true);
      this._offerService.searchOffersByString(this.formControl.value, this.page)
        .subscribe((result) => this.searchCallback(result));
    }
  }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.setInitialCustomers();
    this.offers = [];
    this._subscriptions.push(...[
      combineLatest([this.formControl.valueChanges.pipe(debounceTime(500)), this._searchImmediately.pipe(startWith([]))]).pipe(filter(_ => !this._searching.value), switchMap(([search]) => {
        this.total = 0;
        this.page.pageNumber = 1;
        this._searching.next(true);
        return this._offerService.searchOffersByString(search, this.page);
      })).subscribe((result: PaginationResponse<Offer[]>) => this.searchCallback(result))
    ])
  }

  search = () => this._searchImmediately.next();
  searchCallback = (result: PaginationResponse<Offer[]>) => {
    if(this.page.pageNumber === 1) this.offers = [];
    this.offers.push(...result.content);
    this.total = result.totalItems;
    this._searching.next(false);
  };

  setInitialCustomers(){
    this._offerService.offers$.pipe(take(1), takeUntil(this._searching.pipe(filter(x => x)))).subscribe((offers: Offer[]) => this.offers = offers as any);
  }

}
